import ClivageEditWorkspace from '../features/clivages/layouts/edit-workspace';

// TSS vite/01 §"Pages are thin". Full-screen clivage edit workspace (own tab).
export default function ClivageEditPage() {
    return <ClivageEditWorkspace />;
}
